import jay from '../assets/images/jay.png'
import kachi from "../assets/images/kachi.png";
import chidi from "../assets/images/chidi.png";

export const reviews = [
  {
    id: 1,
    name: "Dikachi Ibekwe",
    image: kachi,
    role: "C.E.O Lambabros",
    review:
      "I have worked with Protis for the past 1year now, one thing spectacular about the brand is their use of modern design features and elements in their work. Protis goes an extra mile to deliver a topnotch job in the creative industry.",
  },
  {
    id: 2,
    name: "John Jay",
    image: jay,
    role: "C.E.O TiT4E Media",
    review:
      "If you're looking for a tech startup that can help you take your brand to the next level, look no further. They are masters of their craft and will work tirelessly to bring your vision to life.",
  },
  {
    id: 3,
    name: "Chidi Umezurike",
    image: chidi,
    role: "C.E.O Haxell Solutions",
    review:
      "I was blown away by the level of creativity and attention to detail Protis brought to my project. They were able to take my ideas and turn them into something truly unique and memorable.",
  },
];